var map = {
	"./ABBALegend.png": 140,
	"./exampleLegend1.png": 141,
	"./exampleLegend2.png": 142,
	"./exampleLegend3.png": 143,
	"./exampleLegend4.png": 144,
	"./nationalParksLegend.png": 145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;